import { IUserFields } from "@src/views/login/LoginTypes";
import { createModel } from "hox";
import { useEffect, useState } from "react";
import useStorageState from "../hooks/useStorageState";
// import menuDataJson from "../data/menuData.json";
import { IMenuNode } from "../layout/FmsMenu";
import { dictService } from "@src/views/base/dict/DictService";
import { OptionDsType } from "@src/types/FmsTypes";

export type RoleType = {
    id: number,
    name: String,
};



type CmType = {
    collapsed: boolean
}
const initCmState = {
    collapsed: false
}

function useModel() {
    const initUserState: IUserFields = {
        userName: "",
        userCode: "",
        token: "",
        loginType: 'account',
    }
    const [user, setUser, resetUser] = useStorageState<IUserFields>('user', initUserState);

    const [cm, setCm, resetCm] = useStorageState<CmType>('cm', initCmState);

    // const [menuData, setMenuData] = useStorageState<IMenuNode[]>('menuData', menuDataJson as unknown as IMenuNode[]);
    const [menuData, setMenuData] = useStorageState<IMenuNode[]>('menuData', []);
    //用户所有资源权限
    const [resourceAuth, setResourceAuth] = useStorageState<string[]>("user.resource", []);
    const [changePassVisible, setChangePassVisible] = useState(false);

    const [gMsgVisible, setGMsgVisible] = useState(false)
    const [gMsgTotal, setGMsgTotal] = useState(0)


    const toggleMenu = () => {
        setCm({
            ...cm,
            collapsed: !cm.collapsed
        })
    }

    return {
        /** field */
        user,
        setUser,
        resetUser,
        toggleMenu,
        cm,
        resetCm,
        gMsgVisible,
        resourceAuth,
        gMsgTotal,

        /** method */
        initUserState,
        menuData,
        setMenuData,
        changePassVisible,
        setChangePassVisible,
        setGMsgVisible,
        setResourceAuth,
        setGMsgTotal,
        // createMenu,
    };
}

export const useGlobalModel = createModel(useModel)
export default useGlobalModel;
